<template>
  <div v-if="account" class="container mt-4">
    <!-- Success and Error Messages -->
    <div v-if="successMessage" class="alert alert-success d-flex align-items-center">
      <i class="bi bi-check-circle-fill me-2"></i>
      {{ successMessage }}
    </div>
    <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center">
      <i class="bi bi-exclamation-circle-fill me-2"></i>
      {{ errorMessage }}
    </div>

    <div class="card shadow p-4">
      <h4 class="card-title text-center mb-4">
        <i class="bi bi-wallet2 me-2"></i>Payment Details
      </h4>
      <form @submit.prevent="savePayment">
        <!-- Account Details -->
        <div class="mb-3">
          <p><i class="bi bi-person-badge me-2"></i>Account ID: {{ account.id }}</p>
          <p><i class="bi bi-person me-2"></i>User ID: {{ account.user_id }}</p>
          <p><i class="bi bi-people me-2"></i>Teacher ID: {{ account.teacher_id }}</p>
          <p><i class="bi bi-calendar-event me-2"></i>Start Date: {{ account.start_date }}</p>
          <p><i class="bi bi-calendar-check me-2"></i>End Date: {{ account.end_date }}</p>
        </div>

        <!-- Package Details -->
        <div class="mb-3">
          <p><i class="bi bi-clock-history me-2"></i>Duration: {{ account.package.duration }}</p>
          <p><i class="bi bi-calendar-plus me-2"></i>New Start Date: {{ newStartDate }}</p>
          <p><i class="bi bi-calendar-range me-2"></i>New End Date: {{ newEndDate }}</p>
          <p><i class="bi bi-card-list me-2"></i>Status: {{ account.account_status.status_name }}</p>
          <p><i class="bi bi-list-ol me-2"></i>Total Student Level: {{ account.total_students_level }}</p>
          <p><i class="bi bi-book me-2"></i>Total Subjects: {{ account.total_subjects }}</p>
          <p><i class="bi bi-box me-2"></i>Package ID: {{ account.package_id }}</p>
          <p><i class="bi bi-currency-dollar me-2"></i>Package Total Price: {{ account.pkg_total_price }}</p>
        </div>

        <!-- Payment Date Input -->
        <div class="form-group mb-3">
          <label for="paymentDate" class="form-label">
            <i class="bi bi-calendar me-2"></i>Payment Date:
          </label>
          <input type="date" id="paymentDate" class="form-control" v-model="paymentDate">
        </div>

        <!-- Payment Status Radio Buttons -->
        <div class="form-group mb-3">
          <label class="form-label">
            <i class="bi bi-check-circle me-2"></i>Payment Status:
          </label>
          <div class="d-flex gap-3">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="paymentStatus" id="paid" value="3" v-model="paymentStatus">
              <label class="form-check-label" for="paid">Paid</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="paymentStatus" id="notPaid" value="4" v-model="paymentStatus">
              <label class="form-check-label" for="notPaid">Not Paid</label>
            </div>
          </div>
        </div>

        <!-- Save Payment Button -->
        <div class="text-center">
          <button type="submit" class="btn btn-success" :disabled="account.status == 1">
            <i class="bi bi-save me-2"></i>Save Payment
          </button>
        </div>
      </form>
    </div>
  </div>

  <div v-else>
    <p>Loading...</p>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  props: {
    account: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      paymentStatus: '3', // default to 'paid'
      paymentDate: new Date().toISOString().substring(0, 10), // default to today's date
      successMessage: '', // for success message
      errorMessage: '' // for error message
    };
  },


  computed: {
    newStartDate() {
      // New start date is the current account end date
      return this.account.end_date;
    },
    newEndDate() {
      if (this.account.end_date && this.account.package.duration) {
        const startDate = new Date(this.account.end_date);
        const monthsToAdd = this.account.package.duration;
        startDate.setMonth(startDate.getMonth() + monthsToAdd); // Add the duration to the start date
        return startDate.toISOString().substring(0, 10); // Return in 'YYYY-MM-DD' format
      }
      return null;
    }
  },

  methods: {
    savePayment() {
      const paymentData = {
        account_id: this.account.id,
        user_id: this.account.user_id,
        teacher_id: this.account.teacher_id,
        start_date: this.account.start_date,
        end_date: this.account.end_date,
        total_students_level: this.account.total_students_level,
        total_subjects: this.account.total_subjects,
        package_id: this.account.package_id,
        pkg_total_price: this.account.pkg_total_price,
        account_status_id: this.paymentStatus, // '3' for paid, '4' for not paid
        payment_date: this.paymentDate, // payment date from input

        new_start_date: this.newStartDate, // computed new start date
        new_end_date: this.newEndDate // computed new end date
      };

      // Clear previous messages
      this.successMessage = '';
      this.errorMessage = '';

      axios.post('/save-payment', paymentData)
        .then(response => {
          // Set success message
          this.successMessage = 'Payment saved successfully!';
          console.log('Payment saved successfully', response.data);
        })
        .catch(error => {
          // Set error message
          this.errorMessage = 'There was an error saving the payment. Please try again.';
          console.error('Error saving payment:', error);
        });
    }
  }
};
</script>

<style scoped>
.profile-photo {
  max-width: 150px;
  max-height: 150px;
  border-radius: 50%;
  object-fit: cover;
}

.alert {
  margin-bottom: 20px;
}
</style>
